import { createContext } from 'react'

export interface CellarSummary {
  id: string
  name: string
}

export interface CellarContextValue {
  cellars: CellarSummary[]
  cellarId: string | null
  cellarName: string | null
  hasCellar: boolean
  loading: boolean
  refresh: () => void
  selectCellar: (id: string) => void
}

export const CellarContext = createContext<CellarContextValue | undefined>(undefined)
